<template>
  <div class="ActivityDiscount">
    <img src="https://cms.dafang24.com/aliapp/20201202/one.png" />
    <img src="https://cms.dafang24.com/aliapp/20201202/two.png" alt="" />
    <img src="https://cms.dafang24.com/aliapp/20201202/three.png" />
    <img src="https://cms.dafang24.com/aliapp/20201202/fore.png" alt="" />
    <div class="btn btn1">
      <div @click="getActivityDiscount"></div>
    </div>
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: "visitHubei",
  data() {
    return {
      couponList: [
        {
          name: "连租2天减80。",
          OfferID: 394
        },
        {
          name: "连租3天减120。",
          OfferID: 407
        },
        {
          name: "连租4天减160。",
          OfferID: 395
        },
        {
          name: "连租5天减200。",
          OfferID: 408                                            
        },                                       
        {
          name: "连租6天减240。",
          OfferID: 409
        },
        {
          name: "连租7天减280。",
          OfferID: 396
        }
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getActivityDiscount() {
      if (localStorage.getItem("token")) {
        let couponList = this.couponList;
        this.consumerCouponsFn(couponList);
      } else {
        this.flexible.showToast({
          content: "请先登陆/注册！",
          success: () => {
            this.goLogin();
          },
        });
      }
    },
    goLogin() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.openPage.postMessage(
          JSON.stringify({ type: "app", url: "/LonginActivity" })
        );
      } else if (orderSource == 16) {
        dfpanda.openPage(
          JSON.stringify({ type: "app", url: "/app/LonginActivity" })
        );
      }
    },
    goHome() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.goHome.postMessage();
      } else if (orderSource == 16) {
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn(copList) {
      // 获取用户优惠券
      let res = await getConsumerCoupons();
      if (res.Code == 100) {
        let uCoupon = res.Data || [];
        if (uCoupon.length) {
          for (let i in uCoupon) {
            for (let j in copList) {
              if (uCoupon[i].OfferID == copList[j].OfferID) {
                copList.splice(j, 1);
              }
            }
          }
        }
        if (copList.length) {
          let lastRes = false;
          for (let item of copList) {
            let gRes = await this.getDrawCoupon(item.OfferID);
            if (gRes) {
              lastRes = gRes;
            }
          }
          if (lastRes) {
            this.flexible.showToast({
              duration: 1200,
              content: "领取成功！",
            });
          } else {
            this.flexible.showToast({ content: "领取失败，请重试" });
          }
        } else {
          this.flexible.showToast({
            duration: 1200,
            content: "领取成功！",
          });
        }
      } else if (res.Code == 17007) {
        this.goLogin();
      }
    },
    async getDrawCoupon(offerID) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0,
        },
        isLoading: 1,
        loadContent: "获取优惠券...",
      });
      if (res.Code == 100) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>

.ActivityDiscount {
  position: relative;
  img {
    width: 100%;
  }
  .draw {
  position: absolute;
  top: 910px;
  left: 70px;
  width: 615px !important;
  height: 83px;
  display: inline-block;
}
  .btn {
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;
    div {
      display: inline-block;
      /*background-color: rgba(0,0,0, .5);*/
    }
  }
  .btn1 {
    top: 950px;
    div {
      width: 620px;
      height: 320px;
    }
  }
  .showCarList {
    .carListTitle {
      width: 100%;
      padding-top: 60px;
      padding-bottom: 40px;
      text-align: center;
      img {
        width: 272px;
      }
    }
    .cityList {
      display: flex;
      flex-wrap: wrap;
      padding: 0 20px 28px;
      .cityItem {
        width: 128px;
        height: 56px;
        line-height: 56px;
        border: 1px solid #fff; /* no */
        color: #fff;
        margin: 20px 5px 0;
        border-radius: 64px;
        text-align: center;
      }
      .active {
        border-color: #ffd200;
        background-color: #ffd200;
        color: #6063f2;
      }
    }

    .carList {
      .carItem {
        display: flex;
        width: 690px;
        margin: 20px auto 0;
        background-color: #fff;
        border-radius: 28px;
        padding: 30px 40px;
        box-sizing: border-box;
        align-items: center;
        .carImg {
          position: relative;
          img {
            width: 216px;
            height: 110px;
          }
          .hotIcon {
            position: absolute;
            top: -20px;
            right: -10px;
            width: 116px;
            height: 46px;
          }
        }
        .carInfo {
          margin-left: 40px;
          width: 360px;
          .carClass {
            width: 100%;
            color: #232323;
            font-size: 26px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .carCharacteristic {
            font-size: 20px;
            color: #8b8b8b;
            height: 60px;
          }
          .carPrice {
            font-size: 22px;
            color: #8b8b8b;
            .priceIcon {
              color: #ff3600;
              font-size: 26px;
            }
            .priceNum {
              font-size: 40px;
              color: #ff3600;
            }
          }
        }
      }
    }
  }
  .goRentCarBox {
    margin-top: 45px;
    padding-bottom: 60px;
    .goRentCar {
      width: 690px;
      height: 90px;
      margin: 0 auto;
      line-height: 90px;
      text-align: center;
      background-color: #ffd200;
      font-size: 30px;
      color: #7b7ef9;
      border-radius: 45px;
    }
  }
}
</style>
